//

import { NoteListConfig, KirokuMenu } from '@app/models/record.model';
import { StorageEnum } from '@app/shared/enum/storage';

const tagsBaitaru = ['バイタル', 'バイタル（連携）', 'ﾊﾞｲﾀﾙｻｲﾝ', 'ﾊﾞｲﾀﾙ(連携)', '検温'];
const tagsShokuji = ['食事', '食事状態', '食事支援'];
const tagsHaisetsu = ['排泄', '排泄特記', '排泄内容', '排泄観察', '排泄支援 ', '排泄量', '排泄状態', '排泄処置'];
const tagsNyuuyoku = ['清潔入浴', '入浴', '入浴清潔'];
const tagsShienkeika = ['支援経過', '相談記録', '相談指導', '相談支援'];
const tagsGYOUMURENRAKU = ['業務記録', '業務予定', '業務連絡'];



export const defaultNoteListConfig: NoteListConfig = { type: KirokuMenu.EMPTY, screenName: '', isMultipleUser: true, initDaySpan: 0 };
export const kirokuNoteListHomeConfigs: NoteListConfig[] = [
    { type: KirokuMenu.MOUSHIOKURI, screenName: '申し送り', isMultipleUser: true, initDaySpan: 0 },
    { type: KirokuMenu.KYOUNOKIROKU, screenName: '連絡ノート', isMultipleUser: true, initDaySpan: 0 },
    { type: KirokuMenu.GYOUMURENRAKU, screenName: '業務連絡', isMultipleUser: true, initDaySpan: 0, tags: tagsGYOUMURENRAKU, officeOnly: true },
    { type: KirokuMenu.JIBUNGAIRETA, screenName: '自分が入れた', isMultipleUser: true, initDaySpan: 0 },
    { type: KirokuMenu.HITORIBUNNO, screenName: '一人分の記録', isMultipleUser: false, initDaySpan: -7, },
    { type: KirokuMenu.KIROKUKENSAKU, screenName: '記録検索', isMultipleUser: true, initDaySpan: 0 },
    { type: KirokuMenu.SHIENKEIKA, screenName: 'シエンケイカ', isMultipleUser: false, initDaySpan: -30, tags: tagsShienkeika },
    { type: KirokuMenu.CASEFILE, screenName: 'ケースファイル', isMultipleUser: false, initDaySpan: -7 },
];
export const kirokuNoteListConfigs: NoteListConfig[] = [
    defaultNoteListConfig,
    ...kirokuNoteListHomeConfigs,
    { type: KirokuMenu.HAISETSUCHUUISHA, screenName: '排せつ注意者', isMultipleUser: true, initDaySpan: 0 },
    { type: KirokuMenu.KYOUNOBAITARU, screenName: '今日のバイタル', isMultipleUser: true, initDaySpan: 0, tags: tagsBaitaru },
    { type: KirokuMenu.KYOUNOSHOKUJI, screenName: '今日の食事', isMultipleUser: true, initDaySpan: 0, tags: tagsShokuji },
    { type: KirokuMenu.KYOUNOHAISETSU, screenName: '今日の排泄', isMultipleUser: true, initDaySpan: 0, tags: tagsHaisetsu },
    { type: KirokuMenu.KYOUNONYUUYOKU, screenName: '今日の入浴', isMultipleUser: true, initDaySpan: 0, tags: tagsNyuuyoku },
    { type: KirokuMenu.ONDOBAN, screenName: '温度板', isMultipleUser: false, initDaySpan: 0 },
    { type: KirokuMenu.ONDOBANICHIRAN, screenName: '温度板一覧', isMultipleUser: true, initDaySpan: 0 },
];



// moment date config
export const unitOfTime = 'date';
export const unitOfSpan = 'days'
export const timeFormat = 'YYYY-MM-DD HH:mm';
// storage config
export const storageChangeKey: string[] = [StorageEnum.MENU_ITEM, StorageEnum.MENU, StorageEnum.CONDITION]
// facesheet
export const facesheetHeader = '帳票の入力';